import { Logs, Master, Transaction } from "../../../assets/svg-icons";
import { authState, getFirstAccessibleRoute, processNodeAndPermissions } from "../../../helper/com-helper";
import { customEntityRoutes } from "../../../helper/commonHelper";

const customEntityMenu = customEntityRoutes && customEntityRoutes();

const EDM_OBJECT = {
  name: "Enterprise Data Management",
  route: "/edm/product",
  permissions: [],
  child: {
    "Masters Data": {
      name: "Masters Data",
      route: null,
      permissions: [],
      icon: Master,
      shortName: "Masters",
      child: {
        Product: {
          name: "Product",
          route: "/edm/product",
          permissions: ["PRODUCT_VIEW"],
        },
        "Product Packaging Hierarchy": {
          name: "Product Packaging Hierarchy",
          route: "/edm/product-packaging-hierarchy",
          permissions: ["PRODUCT_PACKAGING_HIERARCHY_VIEW"],
        },
        "Packaging Container": {
          name: "Packaging Container",
          route: "/edm/packaging-container",
          permissions: ["PACKAGING_CONTAINER_VIEW"],
        },
        "SKU Packaging Container Rules": {
          name: "SKU Packaging Container Rules",
          route: "/edm/sku-packaging-container-rules",
          permissions: ["SKU_PACKAGING_CONTAINER_RULES_VIEW"],
        },
        "Vehicle Type": {
          name: "Vehicle Type",
          route: "/edm/vehicle-type",
          permissions: ["VEHICLE_TYPE_VIEW"],
        },
        Location: {
          name: "Location",
          route: "/edm/location",
          permissions: ["LOCATION_VIEW"],
        },
        Mapping: {
          name: "Mapping",
          route: "/edm/mapping",
          permissions: ["MAPPING_VIEW"],
        },
        Network: {
          name: "Network",
          route: "/edm/network",
          permissions: ["NETWORK_VIEW"],
        },
        Personnel: {
          name: "Personnel",
          route: "/edm/personnel",
          permissions: ["PERSONNEL_VIEW"],
        },
        Currency: {
          name: "Currency",
          route: "/edm/currency",
          permissions: ["CURRENCY_VIEW"],
        },
        Transporter: {
          name: "Transporter",
          route: "/edm/transporter",
          permissions: ["TRANSPORTER_VIEW"],
        },
        "Transporter Network Mapping": {
          name: "Transporter Network Mapping",
          route: "/edm/transporter-network-mapping",
          permissions: ["TRANSPORTER_NETWORK_MAPPING_VIEW"],
        },
        "Transporter Freight": {
          name: "Transporter Freight",
          route: "/edm/transporter-freight",
          permissions: ["TRANSPORTER_FREIGHT_VIEW"],
        },
        "Product Batch Master": {
          name: "Product Batch Master",
          route: "/edm/product-batch-master",
          permissions: ["PRODUCT_BATCH_MASTER_VIEW"],
        },
        Vehicle: {
          name: "Vehicle",
          route: "/edm/entity-management/master/vehicle-entity",
          permissions: ["VEHICLE_VIEW"],
        },
        "Raw Material": {
          name: "Raw Material",
          route: "/edm/raw-material",
          permissions: ["RAW_MATERIAL_VIEW"],
        },
        "Bill Of Materials": {
          name: "Bill Of Materials",
          permissions: ["BILL_OF_MATERIALS"],
          route: "/edm/bill-of-materials",
        },
        // "RM Node Mapping": {
        //   name: "RM Node Mapping",
        //   route: "/edm/rm-node-mapping",
        //   permissions: ["RM_NODE_MAPPING"],
        // },
        Budget: {
          name: "Budget",
          route: "/edm/budget",
          permissions: ["BUDGET_VIEW"],
        },
        // "Marketing Events": {
        //   name: "Marketing Events",
        //   route: "/edm/marketing-events",
        //   permissions: ["MARKETING_EVENTS_VIEW"],
        // },
        "Promotion Type": {
          name: "Promotion Type",
          route: "/edm/promotion-type",
          permissions: ["PROMOTION_TYPES_VIEW"],
        },
        // Split: {
        //   name: "Split",
        //   route: "/edm/splitmaster",
        //   permissions: ["SPLIT_VIEW"],
        // },
        Promotions: {
          name: "Promotions",
          route: "/edm/promo-master",
          permissions: ["PROMO_MASTER_VIEW"],
        },
        "RM Network": {
          name: "RM Network",
          route: "/edm/rm-network",
          permissions: ["RM_NETWORK_VIEW"],
        },

        "Line": {
          name: "Line",
          route: "/edm/line",
          permissions: ["LINE_VIEW"],
        },
        "Machine": {
          name: "Machine",
          route: "/edm/machine",
          permissions: ["MACHINE_VIEW"],
        },
        "Line Machine Mapping": {
          name: "Line Machine Mapping",
          route: "/edm/line-machine-mapping",
          permissions: ["LINE_MACHINE_MAPPING_VIEW"],
        },
        "Node Line Mapping": {
          name: "Node Line Mapping",
          route: "/edm/node-line-mapping",
          permissions: ["NODE_LINE_MAPPING_VIEW"],
        },
        "Node Line Machine Mapping": {
          name: "Node Line Machine Mapping",
          route: "/edm/node-line-machine-mapping",
          permissions: ["NODE_LINE_MACHINE_MAPPING_VIEW"],
        },
        "SKU Node Line Mapping": {
          name: "SKU Node Line Mapping",
          route: "/edm/sku-node-line-mapping",
          permissions: ["SKU_NODE_LINE_MAPPING_VIEW"],
        },
        "SKU Node Line Machine Mapping": {
          name: "SKU Node Line Machine Mapping",
          route: "/edm/sku-node-line-machine-mapping",
          permissions: ["SKU_NODE_LINE_MACHINE_MAPPING_VIEW"],
        },
        "Workforce Availability": {
          name: "Workforce Availability",
          route: "/edm/workforce-availability",
          permissions: ["WORKFORCE_AVAILABILITY_VIEW"],
        },
        "Machine Roaster": {
          name: "Machine Roaster",
          route: "/edm/machine-roaster",
          permissions: ["MACHINE_ROASTER_VIEW"],
        },
        "Machine Blocker Periods": {
          name: "Machine Blocker Periods",
          route: "/edm/machine-blocker-periods",
          permissions: ["MACHINE_BLOCKER_PERIODS_VIEW"],
        },
        "Machine Changeover": {
          name: "Machine Changeover",
          route: "/edm/machine-changeover",
          permissions: ["MACHINE_CHANGEOVER_VIEW"],
        },
        "Event Calendar": {
          name: "Event Calendar",
          route: "/edm/eventcalendar",
          permissions: ["EVENT_CALENDAR_VIEW"],
        },
        "UOM Conversion": {
          name: "UOM Conversion",
          route: "/edm/uom-conversion",
          permissions: ["UOM_CONVERSION_VIEW"],
        },
      },
    },
    "Transaction Data": {
      name: "Transaction Data",
      route: null,
      permissions: [],
      icon: Transaction,
      shortName: "Tracxn",
      child: {
        "Actual Sales History": {
          name: "Actual Sales History",
          permissions: ["SALESHISTORY_VIEW"],
          route: "/edm/actual-sales-history",
        },
        "Sales Order": {
          name: "Sales Order",
          permissions: ["SALES_ORDER__VIEW"],
          route: "/edm/sales-orders",
        },
        Feature: {
          name: "Feature",
          permissions: ["FEATURES_VIEW"],
          route: "/edm/feature",
        },
        Forecast: {
          name: "Forecast",
          permissions: ["FORECASTSUMMARY_VIEW"],
          route: "/edm/forecast-summary",
        },
        Invoice: {
          name: "Invoice",
          permissions: ["INVOICE_VIEW"],
          route: "/edm/invoice",
        },
        "Invoice Line": {
          name: "Invoice Line",
          permissions: ["INVOICE_LINE_VIEW"],
          route: "/edm/invoice-line",
        },
        "Invoice Line Tax": {
          name: "Invoice Line Tax",
          permissions: ["INVOICE_LINE_TAX_VIEW"],
          route: "/edm/invoice-line-tax",
        },
        "Scope 1": {
          name: "Scope 1",
          permissions: ["SCOPE_1_VIEW"],
          route: "/edm/entity-management/transactional/scope-1",
        },
        "Scope 2": {
          name: "Scope 2",
          permissions: ["SCOPE_2_VIEW"],
          route: "/edm/entity-management/transactional/scope-2",
        },
        "Scope 3.1": {
          name: "Scope 3.1",
          permissions: ["SCOPE_3_1_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-1",
        },
        "Scope 3.2": {
          name: "Scope 3.2",
          permissions: ["SCOPE_3_2_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-2",
        },
        "Scope 3.3": {
          name: "Scope 3.3",
          permissions: ["SCOPE_3_3_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-3",
        },
        "Scope 3.4": {
          name: "Scope 3.4",
          permissions: ["SCOPE_3_4_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-4",
        },
        "Scope 3.5": {
          name: "Scope 3.5",
          permissions: ["SCOPE_3_5_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-5",
        },
        "Scope 3.6": {
          name: "Scope 3.6",
          permissions: ["SCOPE_3_6_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-6",
        },
        "Scope 3.7": {
          name: "Scope 3.7",
          permissions: ["SCOPE_3_7_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-7",
        },
        "Scope 3.8": {
          name: "Scope 3.8",
          permissions: ["SCOPE_3_8_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-8",
        },
        "Scope 3.9": {
          name: "Scope 3.9",
          permissions: ["SCOPE_3_9_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-9",
        },
        "Scope 3.10": {
          name: "Scope 3.10",
          permissions: ["SCOPE_3_10_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-10",
        },
        "Scope 3.11": {
          name: "Scope 3.11",
          permissions: ["SCOPE_3_11_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-11",
        },
        "Scope 3.12": {
          name: "Scope 3.12",
          permissions: ["SCOPE_3_12_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-12",
        },
        "Scope 3.13": {
          name: "Scope 3.13",
          permissions: ["SCOPE_3_13_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-13",
        },
        "Scope 3.14": {
          name: "Scope 3.14",
          permissions: ["SCOPE_3_14_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-14",
        },
        "Scope 3.15": {
          name: "Scope 3.15",
          permissions: ["SCOPE_3_15_VIEW"],
          route: "/edm/entity-management/transactional/scope-3-15",
        },
        "Goods In Transit": {
          name: "Goods In Transit",
          permissions: ["GOODS_IN_TRANSIT"],
          route: "/edm/goods-in-transit",
        },
        "Goods In Hand": {
          name: "Goods In Hand",
          permissions: ["GOODS_IN_HAND"],
          route: "/edm/goods-in-hand",
        },
        "Goods In PBNS": {
          name: "Goods In PBNS",
          permissions: ["GOODS_IN_PBNS"],
          route: "/edm/goods-in-pbns",
        },
        "Production Work Order": {
          name: "Production Work Order",
          permissions: ["PRODUCTION_WORK_ORDER"],
          route: "/edm/production-work-order",
        },

        "Stock Transfer Order": {
          name: "Stock Transfer Order",
          permissions: ["STOCK_TRANSFER_ORDER"],
          route: "/edm/stock-transfer-order",
        },
        "Purchase Order": {
          name: "Purchase Order",
          permissions: ["PURCHASE_ORDER"],
          route: "/edm/purchase-order",
        },
        "Raw Material Purchase Order": {
          name: "Raw Material Purchase Order",
          permissions: ["ROW_MATERIAL_PURCHASE_ORDER"],
          route: "/edm/rmpo",
        },

        "Promotion Transactions": {
          name: "Promotion Transactions",
          permissions: ["PROMO_TRANSACTION_VIEW"],
          route: "/edm/promo-transaction",
        },
        "SNP Norms": {
          name: "SNP Norm",
          permissions: ["SNP_NORMS_VIEW"],
          route: "/edm/snp-norms",
        },
        "Actual Production Order": {
          name: "Actual Production Order",
          permissions: ["ACTUAL_PRODUCTION_ORDERS_VIEW"],
          route: "/edm/actual-production-order",
        },




      },
    },
    "Collaboration Data": {
      name: "Collaboration Data",
      route: null,
      permissions: [],
      icon: Master,
      shortName: "Collab",
      child: {
        Product: {
          name: "PIM",
          route: "/edm/collaboration",
          permissions: ["PIM_VIEW"],
        },
        "Create Entity": {
          name: "Create Entity",
          route: "/edm/create-entity",
          permissions: ["CUSTOM_ENTITY"],
        },
        "Custom Entity": {
          name: "Custom Entity",
          route: "/edm/custom-entity",
          permissions: [],
          child: {
            ...(customEntityMenu ? customEntityMenu : {})
          }
        },

      },
    },
    "Transaction Log": {
      name: "Transaction Log",
      route: null,
      permissions: [],
      icon: Logs,
      shortName: "Logs",
      child: {
        "Transaction Log": {
          name: "Transaction Log",
          route: "/edm/transactionlog",
          permissions: ["TRANSACTION_LOG_VIEW"],
        },
        "Insights": {
          name: "Insights",
          route: "/edm/insights",
          permissions: ["TRANSACTION_LOG_VIEW"],
        },

      },
    },
  },
  extraRoutes: [
    {
      route: "/edm/budget/:masterBudgetId",
      permissions: ["BUDGET_VIEW"],
    },
  ],
};

EDM_OBJECT.route = authState.permissions.includes("PRODUCT_VIEW")
  ? "/edm/product"
  : getFirstAccessibleRoute(EDM_OBJECT) ?? "/edm/product";

processNodeAndPermissions(EDM_OBJECT);

export const EDM = EDM_OBJECT;
